const locale = {
	IS_HIDDEN: 'Hidden',
	IS_PERSONAL: 'Personal',

	DETAILS_DOCUMENTS_FOLDERS_FIELD_TITLE: 'Name',
	DETAILS_DOCUMENTS_FOLDERS_FIELD_ORDER: 'Order',
	DETAILS_DOCUMENTS_FOLDERS_FIELD_ACTIVE: 'Active',
	DETAILS_DOCUMENTS_FOLDERS_FIELD_PERSONAL: 'Personal',

	DETAILS_DOCUMENTS_FOLDERS_CONTENT_SECTION: 'Folder content',
	DETAILS_DOCUMENTS_FOLDERS_CONTENT_SECTION_SUBHEADER: 'View the files contained in the folder',

	TAB_USERS_FOLDERS: 'Users Folders',
	DOCUMENTS_VIEW_CONTENT: 'View Content',
	DETAILS_HEADER_BUTTON_FOLDERS_DOCUMENTS_SETTINGS: 'Docs configuration'
};

export default locale;
